var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('button',{staticClass:"btn btn--dark-ad btn--listing-compare tx-14 flex mb-4 sm:mb-6",on:{"click":function($event){return _vm.addCompare($event)}}},[_vm._m(0),_vm._v(" "),_vm._v("\n        Comparar\n    ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tx-18 mr-2"},[_c('i',{staticClass:"fas fa-exchange-alt"})])
}]

export { render, staticRenderFns }